export type TransformerCause = {
  cause: string;
  probability: number;
};

export type TransformerFault = {
  id: string;
  category_id: string | null;
  device_ar: string;
  name_ar: string;
  description_ar: string;
  symptoms: string[];
  causes: TransformerCause[];
  tests: {
    test: string;
    location: string;
    method: string;
    normal: string;
    faulty: string;
  }[];
  solutions: string[];
  severity: string;
  safety_warnings: string[];
  error_code: string | null;
  keywords: string;
  next_question_key: string | null;
};

type Row = [
  string,
  string,
  string,
  string,
  string,
  TransformerCause[],
  string[],
  string,
  string
];

const C = (cause: string, probability: number): TransformerCause => ({
  cause,
  probability,
});

const rows: Row[] = [
[
  "transformer-001",
  "دخل المحولة الابتدائي",
  "دخل المحولة الابتدائي ما يشتغل أو ما ينفذ وظيفته",
  "وظيفة دخل المحولة الابتدائي متوقفة أو مو موجودة بالصورة الطبيعية.",
  "توقف وظيفة دخل المحولة الابتدائي",
  [C("تغذية أو إشارة مفقودة", 35), C("المكوّن نفسه متضرر", 30), C("توصيل أو حماية مانعة التشغيل", 20), C("تقادم أو ضعف بالعزل", 15)],
  ["افحص التغذية والحماية والتوصيلات.", "بدل أو صلح الجزء المتضرر بعد العزل."],
  "عالية",
  "المحولات primary input HV not working open",
],
[
  "transformer-002",
  "دخل المحولة الابتدائي",
  "حرارة دخل المحولة الابتدائي ترتفع",
  "حرارة دخل المحولة الابتدائي أعلى من الطبيعي أثناء التشغيل.",
  "ارتفاع حرارة دخل المحولة الابتدائي",
  [C("تحميل أعلى من التصميم", 35), C("ربط مقاومته عالية", 30), C("تهوية أو تبريد غير كافي", 20), C("تقادم أو ضعف بالعزل", 15)],
  ["خفف الحمل إذا ممكن وافحص التبريد.", "اعزل المعدة إذا الحرارة أو ريحة الحرك قوية."],
  "حرجة",
  "المحولات primary input HV overheating hot",
],
[
  "transformer-003",
  "دخل المحولة الابتدائي",
  "دخل المحولة الابتدائي يشتغل أو يقرا بصورة غير مستقرة",
  "أداء أو قراءة دخل المحولة الابتدائي تتغير أو تقطع بدون سبب طبيعي.",
  "تشغيل أو قراءة متقطعة",
  [C("ترمنل أو وصلة مرخية", 35), C("تغذية أو إشارة متذبذبة", 30), C("المكوّن بدأ يتدهور", 20), C("تقادم أو ضعف بالعزل", 15)],
  ["راقب الحالة وقت ظهور العطل.", "افحص الربطات والتغذية والإشارة المرتبطة بالمكوّن."],
  "عالية",
  "المحولات primary input HV intermittent unstable",
],
[
  "transformer-004",
  "دخل المحولة الابتدائي",
  "دخل المحولة الابتدائي بيه ربط أو توصيل مو صحيح",
  "أكو ربط مرخي أو توصيل مو مطابق أو نقطة تلامس ضعيفة مرتبطة بـ دخل المحولة الابتدائي.",
  "ربط أو توصيل غير سليم",
  [C("برغي أو ترمنل مرخي", 35), C("توصيل سابق مو مطابق", 30), C("أكسدة أو تلف بنقطة الربط", 20), C("تقادم أو ضعف بالعزل", 15)],
  ["اعزل التغذية قبل إعادة الربط.", "نظف أو بدل اللگ أو الترمنل المتضرر."],
  "حرجة",
  "المحولات primary input HV loose wrong connection",
],
[
  "transformer-005",
  "دخل المحولة الابتدائي",
  "قراءة أو خرج دخل المحولة الابتدائي مو طبيعي",
  "قراءة أو خرج دخل المحولة الابتدائي أعلى أو أقل أو مختلف عن المطلوب.",
  "قراءة أو خرج غير طبيعي",
  [C("إعداد أو معايرة غلط", 35), C("مصدر أو حمل مو طبيعي", 30), C("المكوّن أو الحساس المرتبط بيه متضرر", 20), C("تقادم أو ضعف بالعزل", 15)],
  ["قارن القراءة بالمواصفات أو بقياس مرجعي.", "راجع الإعدادات والمكوّن المرتبط بالقياس."],
  "متوسطة",
  "المحولات primary input HV abnormal reading output",
],
[
  "transformer-006",
  "ملفات الابتدائي",
  "ملفات الابتدائي ما يشتغل أو ما ينفذ وظيفته",
  "وظيفة ملفات الابتدائي متوقفة أو مو موجودة بالصورة الطبيعية.",
  "توقف وظيفة ملفات الابتدائي",
  [C("تغذية أو إشارة مفقودة", 35), C("المكوّن نفسه متضرر", 30), C("توصيل أو حماية مانعة التشغيل", 20), C("تقادم أو ضعف بالعزل", 15)],
  ["افحص التغذية والحماية والتوصيلات.", "بدل أو صلح الجزء المتضرر بعد العزل."],
  "عالية",
  "المحولات primary winding not working open",
],
[
  "transformer-007",
  "ملفات الابتدائي",
  "حرارة ملفات الابتدائي ترتفع",
  "حرارة ملفات الابتدائي أعلى من الطبيعي أثناء التشغيل.",
  "ارتفاع حرارة ملفات الابتدائي",
  [C("تحميل أعلى من التصميم", 35), C("ربط مقاومته عالية", 30), C("تهوية أو تبريد غير كافي", 20), C("تقادم أو ضعف بالعزل", 15)],
  ["خفف الحمل إذا ممكن وافحص التبريد.", "اعزل المعدة إذا الحرارة أو ريحة الحرك قوية."],
  "حرجة",
  "المحولات primary winding overheating hot",
],
[
  "transformer-008",
  "ملفات الابتدائي",
  "ملفات الابتدائي يشتغل أو يقرا بصورة غير مستقرة",
  "أداء أو قراءة ملفات الابتدائي تتغير أو تقطع بدون سبب طبيعي.",
  "تشغيل أو قراءة متقطعة",
  [C("ترمنل أو وصلة مرخية", 35), C("تغذية أو إشارة متذبذبة", 30), C("المكوّن بدأ يتدهور", 20), C("تقادم أو ضعف بالعزل", 15)],
  ["راقب الحالة وقت ظهور العطل.", "افحص الربطات والتغذية والإشارة المرتبطة بالمكوّن."],
  "عالية",
  "المحولات primary winding intermittent unstable",
],
[
  "transformer-009",
  "ملفات الابتدائي",
  "ملفات الابتدائي بيه ربط أو توصيل مو صحيح",
  "أكو ربط مرخي أو توصيل مو مطابق أو نقطة تلامس ضعيفة مرتبطة بـ ملفات الابتدائي.",
  "ربط أو توصيل غير سليم",
  [C("برغي أو ترمنل مرخي", 35), C("توصيل سابق مو مطابق", 30), C("أكسدة أو تلف بنقطة الربط", 20), C("تقادم أو ضعف بالعزل", 15)],
  ["اعزل التغذية قبل إعادة الربط.", "نظف أو بدل اللگ أو الترمنل المتضرر."],
  "حرجة",
  "المحولات primary winding loose wrong connection",
],
[
  "transformer-010",
  "ملفات الابتدائي",
  "قراءة أو خرج ملفات الابتدائي مو طبيعي",
  "قراءة أو خرج ملفات الابتدائي أعلى أو أقل أو مختلف عن المطلوب.",
  "قراءة أو خرج غير طبيعي",
  [C("إعداد أو معايرة غلط", 35), C("مصدر أو حمل مو طبيعي", 30), C("المكوّن أو الحساس المرتبط بيه متضرر", 20), C("تقادم أو ضعف بالعزل", 15)],
  ["قارن القراءة بالمواصفات أو بقياس مرجعي.", "راجع الإعدادات والمكوّن المرتبط بالقياس."],
  "متوسطة",
  "المحولات primary winding abnormal reading output",
],
[
  "transformer-011",
  "ملفات الثانوي",
  "ملفات الثانوي ما يشتغل أو ما ينفذ وظيفته",
  "وظيفة ملفات الثانوي متوقفة أو مو موجودة بالصورة الطبيعية.",
  "توقف وظيفة ملفات الثانوي",
  [C("تغذية أو إشارة مفقودة", 35), C("المكوّن نفسه متضرر", 30), C("توصيل أو حماية مانعة التشغيل", 20), C("تقادم أو ضعف بالعزل", 15)],
  ["افحص التغذية والحماية والتوصيلات.", "بدل أو صلح الجزء المتضرر بعد العزل."],
  "عالية",
  "المحولات secondary winding not working open",
],
[
  "transformer-012",
  "ملفات الثانوي",
  "حرارة ملفات الثانوي ترتفع",
  "حرارة ملفات الثانوي أعلى من الطبيعي أثناء التشغيل.",
  "ارتفاع حرارة ملفات الثانوي",
  [C("تحميل أعلى من التصميم", 35), C("ربط مقاومته عالية", 30), C("تهوية أو تبريد غير كافي", 20), C("تقادم أو ضعف بالعزل", 15)],
  ["خفف الحمل إذا ممكن وافحص التبريد.", "اعزل المعدة إذا الحرارة أو ريحة الحرك قوية."],
  "حرجة",
  "المحولات secondary winding overheating hot",
],
[
  "transformer-013",
  "ملفات الثانوي",
  "ملفات الثانوي يشتغل أو يقرا بصورة غير مستقرة",
  "أداء أو قراءة ملفات الثانوي تتغير أو تقطع بدون سبب طبيعي.",
  "تشغيل أو قراءة متقطعة",
  [C("ترمنل أو وصلة مرخية", 35), C("تغذية أو إشارة متذبذبة", 30), C("المكوّن بدأ يتدهور", 20), C("تقادم أو ضعف بالعزل", 15)],
  ["راقب الحالة وقت ظهور العطل.", "افحص الربطات والتغذية والإشارة المرتبطة بالمكوّن."],
  "عالية",
  "المحولات secondary winding intermittent unstable",
],
[
  "transformer-014",
  "ملفات الثانوي",
  "ملفات الثانوي بيه ربط أو توصيل مو صحيح",
  "أكو ربط مرخي أو توصيل مو مطابق أو نقطة تلامس ضعيفة مرتبطة بـ ملفات الثانوي.",
  "ربط أو توصيل غير سليم",
  [C("برغي أو ترمنل مرخي", 35), C("توصيل سابق مو مطابق", 30), C("أكسدة أو تلف بنقطة الربط", 20), C("تقادم أو ضعف بالعزل", 15)],
  ["اعزل التغذية قبل إعادة الربط.", "نظف أو بدل اللگ أو الترمنل المتضرر."],
  "حرجة",
  "المحولات secondary winding loose wrong connection",
],
[
  "transformer-015",
  "ملفات الثانوي",
  "قراءة أو خرج ملفات الثانوي مو طبيعي",
  "قراءة أو خرج ملفات الثانوي أعلى أو أقل أو مختلف عن المطلوب.",
  "قراءة أو خرج غير طبيعي",
  [C("إعداد أو معايرة غلط", 35), C("مصدر أو حمل مو طبيعي", 30), C("المكوّن أو الحساس المرتبط بيه متضرر", 20), C("تقادم أو ضعف بالعزل", 15)],
  ["قارن القراءة بالمواصفات أو بقياس مرجعي.", "راجع الإعدادات والمكوّن المرتبط بالقياس."],
  "متوسطة",
  "المحولات secondary winding abnormal reading output",
],
[
  "transformer-016",
  "قلب المحولة الحديدي",
  "قلب المحولة الحديدي ما يشتغل أو ما ينفذ وظيفته",
  "وظيفة قلب المحولة الحديدي متوقفة أو مو موجودة بالصورة الطبيعية.",
  "توقف وظيفة قلب المحولة الحديدي",
  [C("تغذية أو إشارة مفقودة", 35), C("المكوّن نفسه متضرر", 30), C("توصيل أو حماية مانعة التشغيل", 20), C("تقادم أو ضعف بالعزل", 15)],
  ["افحص التغذية والحماية والتوصيلات.", "بدل أو صلح الجزء المتضرر بعد العزل."],
  "عالية",
  "المحولات transformer core not working open",
],
[
  "transformer-017",
  "قلب المحولة الحديدي",
  "حرارة قلب المحولة الحديدي ترتفع",
  "حرارة قلب المحولة الحديدي أعلى من الطبيعي أثناء التشغيل.",
  "ارتفاع حرارة قلب المحولة الحديدي",
  [C("تحميل أعلى من التصميم", 35), C("ربط مقاومته عالية", 30), C("تهوية أو تبريد غير كافي", 20), C("تقادم أو ضعف بالعزل", 15)],
  ["خفف الحمل إذا ممكن وافحص التبريد.", "اعزل المعدة إذا الحرارة أو ريحة الحرك قوية."],
  "حرجة",
  "المحولات transformer core overheating hot",
],
[
  "transformer-018",
  "قلب المحولة الحديدي",
  "قلب المحولة الحديدي يشتغل أو يقرا بصورة غير مستقرة",
  "أداء أو قراءة قلب المحولة الحديدي تتغير أو تقطع بدون سبب طبيعي.",
  "تشغيل أو قراءة متقطعة",
  [C("ترمنل أو وصلة مرخية", 35), C("تغذية أو إشارة متذبذبة", 30), C("المكوّن بدأ يتدهور", 20), C("تقادم أو ضعف بالعزل", 15)],
  ["راقب الحالة وقت ظهور العطل.", "افحص الربطات والتغذية والإشارة المرتبطة بالمكوّن."],
  "عالية",
  "المحولات transformer core intermittent unstable",
],
[
  "transformer-019",
  "قلب المحولة الحديدي",
  "قلب المحولة الحديدي بيه ربط أو توصيل مو صحيح",
  "أكو ربط مرخي أو توصيل مو مطابق أو نقطة تلامس ضعيفة مرتبطة بـ قلب المحولة الحديدي.",
  "ربط أو توصيل غير سليم",
  [C("برغي أو ترمنل مرخي", 35), C("توصيل سابق مو مطابق", 30), C("أكسدة أو تلف بنقطة الربط", 20), C("تقادم أو ضعف بالعزل", 15)],
  ["اعزل التغذية قبل إعادة الربط.", "نظف أو بدل اللگ أو الترمنل المتضرر."],
  "حرجة",
  "المحولات transformer core loose wrong connection",
],
[
  "transformer-020",
  "قلب المحولة الحديدي",
  "قراءة أو خرج قلب المحولة الحديدي مو طبيعي",
  "قراءة أو خرج قلب المحولة الحديدي أعلى أو أقل أو مختلف عن المطلوب.",
  "قراءة أو خرج غير طبيعي",
  [C("إعداد أو معايرة غلط", 35), C("مصدر أو حمل مو طبيعي", 30), C("المكوّن أو الحساس المرتبط بيه متضرر", 20), C("تقادم أو ضعف بالعزل", 15)],
  ["قارن القراءة بالمواصفات أو بقياس مرجعي.", "راجع الإعدادات والمكوّن المرتبط بالقياس."],
  "متوسطة",
  "المحولات transformer core abnormal reading output",
],
[
  "transformer-021",
  "زيت المحولة",
  "زيت المحولة ما يشتغل أو ما ينفذ وظيفته",
  "وظيفة زيت المحولة متوقفة أو مو موجودة بالصورة الطبيعية.",
  "توقف وظيفة زيت المحولة",
  [C("تغذية أو إشارة مفقودة", 35), C("المكوّن نفسه متضرر", 30), C("توصيل أو حماية مانعة التشغيل", 20), C("تقادم أو ضعف بالعزل", 15)],
  ["افحص التغذية والحماية والتوصيلات.", "بدل أو صلح الجزء المتضرر بعد العزل."],
  "عالية",
  "المحولات transformer oil not working open",
],
[
  "transformer-022",
  "زيت المحولة",
  "حرارة زيت المحولة ترتفع",
  "حرارة زيت المحولة أعلى من الطبيعي أثناء التشغيل.",
  "ارتفاع حرارة زيت المحولة",
  [C("تحميل أعلى من التصميم", 35), C("ربط مقاومته عالية", 30), C("تهوية أو تبريد غير كافي", 20), C("تقادم أو ضعف بالعزل", 15)],
  ["خفف الحمل إذا ممكن وافحص التبريد.", "اعزل المعدة إذا الحرارة أو ريحة الحرك قوية."],
  "حرجة",
  "المحولات transformer oil overheating hot",
],
[
  "transformer-023",
  "زيت المحولة",
  "زيت المحولة يشتغل أو يقرا بصورة غير مستقرة",
  "أداء أو قراءة زيت المحولة تتغير أو تقطع بدون سبب طبيعي.",
  "تشغيل أو قراءة متقطعة",
  [C("ترمنل أو وصلة مرخية", 35), C("تغذية أو إشارة متذبذبة", 30), C("المكوّن بدأ يتدهور", 20), C("تقادم أو ضعف بالعزل", 15)],
  ["راقب الحالة وقت ظهور العطل.", "افحص الربطات والتغذية والإشارة المرتبطة بالمكوّن."],
  "عالية",
  "المحولات transformer oil intermittent unstable",
],
[
  "transformer-024",
  "زيت المحولة",
  "زيت المحولة بيه ربط أو توصيل مو صحيح",
  "أكو ربط مرخي أو توصيل مو مطابق أو نقطة تلامس ضعيفة مرتبطة بـ زيت المحولة.",
  "ربط أو توصيل غير سليم",
  [C("برغي أو ترمنل مرخي", 35), C("توصيل سابق مو مطابق", 30), C("أكسدة أو تلف بنقطة الربط", 20), C("تقادم أو ضعف بالعزل", 15)],
  ["اعزل التغذية قبل إعادة الربط.", "نظف أو بدل اللگ أو الترمنل المتضرر."],
  "حرجة",
  "المحولات transformer oil loose wrong connection",
],
[
  "transformer-025",
  "زيت المحولة",
  "قراءة أو خرج زيت المحولة مو طبيعي",
  "قراءة أو خرج زيت المحولة أعلى أو أقل أو مختلف عن المطلوب.",
  "قراءة أو خرج غير طبيعي",
  [C("إعداد أو معايرة غلط", 35), C("مصدر أو حمل مو طبيعي", 30), C("المكوّن أو الحساس المرتبط بيه متضرر", 20), C("تقادم أو ضعف بالعزل", 15)],
  ["قارن القراءة بالمواصفات أو بقياس مرجعي.", "راجع الإعدادات والمكوّن المرتبط بالقياس."],
  "متوسطة",
  "المحولات transformer oil abnormal reading output",
],
[
  "transformer-026",
  "مستوى الزيت",
  "مستوى الزيت ما يشتغل أو ما ينفذ وظيفته",
  "وظيفة مستوى الزيت متوقفة أو مو موجودة بالصورة الطبيعية.",
  "توقف وظيفة مستوى الزيت",
  [C("تغذية أو إشارة مفقودة", 35), C("المكوّن نفسه متضرر", 30), C("توصيل أو حماية مانعة التشغيل", 20), C("تقادم أو ضعف بالعزل", 15)],
  ["افحص التغذية والحماية والتوصيلات.", "بدل أو صلح الجزء المتضرر بعد العزل."],
  "عالية",
  "المحولات oil level not working open",
],
[
  "transformer-027",
  "مستوى الزيت",
  "حرارة مستوى الزيت ترتفع",
  "حرارة مستوى الزيت أعلى من الطبيعي أثناء التشغيل.",
  "ارتفاع حرارة مستوى الزيت",
  [C("تحميل أعلى من التصميم", 35), C("ربط مقاومته عالية", 30), C("تهوية أو تبريد غير كافي", 20), C("تقادم أو ضعف بالعزل", 15)],
  ["خفف الحمل إذا ممكن وافحص التبريد.", "اعزل المعدة إذا الحرارة أو ريحة الحرك قوية."],
  "حرجة",
  "المحولات oil level overheating hot",
],
[
  "transformer-028",
  "مستوى الزيت",
  "مستوى الزيت يشتغل أو يقرا بصورة غير مستقرة",
  "أداء أو قراءة مستوى الزيت تتغير أو تقطع بدون سبب طبيعي.",
  "تشغيل أو قراءة متقطعة",
  [C("ترمنل أو وصلة مرخية", 35), C("تغذية أو إشارة متذبذبة", 30), C("المكوّن بدأ يتدهور", 20), C("تقادم أو ضعف بالعزل", 15)],
  ["راقب الحالة وقت ظهور العطل.", "افحص الربطات والتغذية والإشارة المرتبطة بالمكوّن."],
  "عالية",
  "المحولات oil level intermittent unstable",
],
[
  "transformer-029",
  "مستوى الزيت",
  "مستوى الزيت بيه ربط أو توصيل مو صحيح",
  "أكو ربط مرخي أو توصيل مو مطابق أو نقطة تلامس ضعيفة مرتبطة بـ مستوى الزيت.",
  "ربط أو توصيل غير سليم",
  [C("برغي أو ترمنل مرخي", 35), C("توصيل سابق مو مطابق", 30), C("أكسدة أو تلف بنقطة الربط", 20), C("تقادم أو ضعف بالعزل", 15)],
  ["اعزل التغذية قبل إعادة الربط.", "نظف أو بدل اللگ أو الترمنل المتضرر."],
  "حرجة",
  "المحولات oil level loose wrong connection",
],
[
  "transformer-030",
  "مستوى الزيت",
  "قراءة أو خرج مستوى الزيت مو طبيعي",
  "قراءة أو خرج مستوى الزيت أعلى أو أقل أو مختلف عن المطلوب.",
  "قراءة أو خرج غير طبيعي",
  [C("إعداد أو معايرة غلط", 35), C("مصدر أو حمل مو طبيعي", 30), C("المكوّن أو الحساس المرتبط بيه متضرر", 20), C("تقادم أو ضعف بالعزل", 15)],
  ["قارن القراءة بالمواصفات أو بقياس مرجعي.", "راجع الإعدادات والمكوّن المرتبط بالقياس."],
  "متوسطة",
  "المحولات oil level abnormal reading output",
],
[
  "transformer-031",
  "Conservator خزان التمدد",
  "Conservator خزان التمدد ما يشتغل أو ما ينفذ وظيفته",
  "وظيفة Conservator خزان التمدد متوقفة أو مو موجودة بالصورة الطبيعية.",
  "توقف وظيفة Conservator خزان التمدد",
  [C("تغذية أو إشارة مفقودة", 35), C("المكوّن نفسه متضرر", 30), C("توصيل أو حماية مانعة التشغيل", 20), C("تقادم أو ضعف بالعزل", 15)],
  ["افحص التغذية والحماية والتوصيلات.", "بدل أو صلح الجزء المتضرر بعد العزل."],
  "عالية",
  "المحولات conservator not working open",
],
[
  "transformer-032",
  "Conservator خزان التمدد",
  "حرارة Conservator خزان التمدد ترتفع",
  "حرارة Conservator خزان التمدد أعلى من الطبيعي أثناء التشغيل.",
  "ارتفاع حرارة Conservator خزان التمدد",
  [C("تحميل أعلى من التصميم", 35), C("ربط مقاومته عالية", 30), C("تهوية أو تبريد غير كافي", 20), C("تقادم أو ضعف بالعزل", 15)],
  ["خفف الحمل إذا ممكن وافحص التبريد.", "اعزل المعدة إذا الحرارة أو ريحة الحرك قوية."],
  "حرجة",
  "المحولات conservator overheating hot",
],
[
  "transformer-033",
  "Conservator خزان التمدد",
  "Conservator خزان التمدد يشتغل أو يقرا بصورة غير مستقرة",
  "أداء أو قراءة Conservator خزان التمدد تتغير أو تقطع بدون سبب طبيعي.",
  "تشغيل أو قراءة متقطعة",
  [C("ترمنل أو وصلة مرخية", 35), C("تغذية أو إشارة متذبذبة", 30), C("المكوّن بدأ يتدهور", 20), C("تقادم أو ضعف بالعزل", 15)],
  ["راقب الحالة وقت ظهور العطل.", "افحص الربطات والتغذية والإشارة المرتبطة بالمكوّن."],
  "عالية",
  "المحولات conservator intermittent unstable",
],
[
  "transformer-034",
  "Conservator خزان التمدد",
  "Conservator خزان التمدد بيه ربط أو توصيل مو صحيح",
  "أكو ربط مرخي أو توصيل مو مطابق أو نقطة تلامس ضعيفة مرتبطة بـ Conservator خزان التمدد.",
  "ربط أو توصيل غير سليم",
  [C("برغي أو ترمنل مرخي", 35), C("توصيل سابق مو مطابق", 30), C("أكسدة أو تلف بنقطة الربط", 20), C("تقادم أو ضعف بالعزل", 15)],
  ["اعزل التغذية قبل إعادة الربط.", "نظف أو بدل اللگ أو الترمنل المتضرر."],
  "حرجة",
  "المحولات conservator loose wrong connection",
],
[
  "transformer-035",
  "Conservator خزان التمدد",
  "قراءة أو خرج Conservator خزان التمدد مو طبيعي",
  "قراءة أو خرج Conservator خزان التمدد أعلى أو أقل أو مختلف عن المطلوب.",
  "قراءة أو خرج غير طبيعي",
  [C("إعداد أو معايرة غلط", 35), C("مصدر أو حمل مو طبيعي", 30), C("المكوّن أو الحساس المرتبط بيه متضرر", 20), C("تقادم أو ضعف بالعزل", 15)],
  ["قارن القراءة بالمواصفات أو بقياس مرجعي.", "راجع الإعدادات والمكوّن المرتبط بالقياس."],
  "متوسطة",
  "المحولات conservator abnormal reading output",
],
[
  "transformer-036",
  "Breather وSilica Gel",
  "Breather وSilica Gel ما يشتغل أو ما ينفذ وظيفته",
  "وظيفة Breather وSilica Gel متوقفة أو مو موجودة بالصورة الطبيعية.",
  "توقف وظيفة Breather وSilica Gel",
  [C("تغذية أو إشارة مفقودة", 35), C("المكوّن نفسه متضرر", 30), C("توصيل أو حماية مانعة التشغيل", 20), C("تقادم أو ضعف بالعزل", 15)],
  ["افحص التغذية والحماية والتوصيلات.", "بدل أو صلح الجزء المتضرر بعد العزل."],
  "عالية",
  "المحولات breather silica gel not working open",
],
[
  "transformer-037",
  "Breather وSilica Gel",
  "حرارة Breather وSilica Gel ترتفع",
  "حرارة Breather وSilica Gel أعلى من الطبيعي أثناء التشغيل.",
  "ارتفاع حرارة Breather وSilica Gel",
  [C("تحميل أعلى من التصميم", 35), C("ربط مقاومته عالية", 30), C("تهوية أو تبريد غير كافي", 20), C("تقادم أو ضعف بالعزل", 15)],
  ["خفف الحمل إذا ممكن وافحص التبريد.", "اعزل المعدة إذا الحرارة أو ريحة الحرك قوية."],
  "حرجة",
  "المحولات breather silica gel overheating hot",
],
[
  "transformer-038",
  "Breather وSilica Gel",
  "Breather وSilica Gel يشتغل أو يقرا بصورة غير مستقرة",
  "أداء أو قراءة Breather وSilica Gel تتغير أو تقطع بدون سبب طبيعي.",
  "تشغيل أو قراءة متقطعة",
  [C("ترمنل أو وصلة مرخية", 35), C("تغذية أو إشارة متذبذبة", 30), C("المكوّن بدأ يتدهور", 20), C("تقادم أو ضعف بالعزل", 15)],
  ["راقب الحالة وقت ظهور العطل.", "افحص الربطات والتغذية والإشارة المرتبطة بالمكوّن."],
  "عالية",
  "المحولات breather silica gel intermittent unstable",
],
[
  "transformer-039",
  "Breather وSilica Gel",
  "Breather وSilica Gel بيه ربط أو توصيل مو صحيح",
  "أكو ربط مرخي أو توصيل مو مطابق أو نقطة تلامس ضعيفة مرتبطة بـ Breather وSilica Gel.",
  "ربط أو توصيل غير سليم",
  [C("برغي أو ترمنل مرخي", 35), C("توصيل سابق مو مطابق", 30), C("أكسدة أو تلف بنقطة الربط", 20), C("تقادم أو ضعف بالعزل", 15)],
  ["اعزل التغذية قبل إعادة الربط.", "نظف أو بدل اللگ أو الترمنل المتضرر."],
  "حرجة",
  "المحولات breather silica gel loose wrong connection",
],
[
  "transformer-040",
  "Breather وSilica Gel",
  "قراءة أو خرج Breather وSilica Gel مو طبيعي",
  "قراءة أو خرج Breather وSilica Gel أعلى أو أقل أو مختلف عن المطلوب.",
  "قراءة أو خرج غير طبيعي",
  [C("إعداد أو معايرة غلط", 35), C("مصدر أو حمل مو طبيعي", 30), C("المكوّن أو الحساس المرتبط بيه متضرر", 20), C("تقادم أو ضعف بالعزل", 15)],
  ["قارن القراءة بالمواصفات أو بقياس مرجعي.", "راجع الإعدادات والمكوّن المرتبط بالقياس."],
  "متوسطة",
  "المحولات breather silica gel abnormal reading output",
],
[
  "transformer-041",
  "Bushing الجهد العالي",
  "Bushing الجهد العالي ما يشتغل أو ما ينفذ وظيفته",
  "وظيفة Bushing الجهد العالي متوقفة أو مو موجودة بالصورة الطبيعية.",
  "توقف وظيفة Bushing الجهد العالي",
  [C("تغذية أو إشارة مفقودة", 35), C("المكوّن نفسه متضرر", 30), C("توصيل أو حماية مانعة التشغيل", 20), C("تقادم أو ضعف بالعزل", 15)],
  ["افحص التغذية والحماية والتوصيلات.", "بدل أو صلح الجزء المتضرر بعد العزل."],
  "عالية",
  "المحولات HV bushing not working open",
],
[
  "transformer-042",
  "Bushing الجهد العالي",
  "حرارة Bushing الجهد العالي ترتفع",
  "حرارة Bushing الجهد العالي أعلى من الطبيعي أثناء التشغيل.",
  "ارتفاع حرارة Bushing الجهد العالي",
  [C("تحميل أعلى من التصميم", 35), C("ربط مقاومته عالية", 30), C("تهوية أو تبريد غير كافي", 20), C("تقادم أو ضعف بالعزل", 15)],
  ["خفف الحمل إذا ممكن وافحص التبريد.", "اعزل المعدة إذا الحرارة أو ريحة الحرك قوية."],
  "حرجة",
  "المحولات HV bushing overheating hot",
],
[
  "transformer-043",
  "Bushing الجهد العالي",
  "Bushing الجهد العالي يشتغل أو يقرا بصورة غير مستقرة",
  "أداء أو قراءة Bushing الجهد العالي تتغير أو تقطع بدون سبب طبيعي.",
  "تشغيل أو قراءة متقطعة",
  [C("ترمنل أو وصلة مرخية", 35), C("تغذية أو إشارة متذبذبة", 30), C("المكوّن بدأ يتدهور", 20), C("تقادم أو ضعف بالعزل", 15)],
  ["راقب الحالة وقت ظهور العطل.", "افحص الربطات والتغذية والإشارة المرتبطة بالمكوّن."],
  "عالية",
  "المحولات HV bushing intermittent unstable",
],
[
  "transformer-044",
  "Bushing الجهد العالي",
  "Bushing الجهد العالي بيه ربط أو توصيل مو صحيح",
  "أكو ربط مرخي أو توصيل مو مطابق أو نقطة تلامس ضعيفة مرتبطة بـ Bushing الجهد العالي.",
  "ربط أو توصيل غير سليم",
  [C("برغي أو ترمنل مرخي", 35), C("توصيل سابق مو مطابق", 30), C("أكسدة أو تلف بنقطة الربط", 20), C("تقادم أو ضعف بالعزل", 15)],
  ["اعزل التغذية قبل إعادة الربط.", "نظف أو بدل اللگ أو الترمنل المتضرر."],
  "حرجة",
  "المحولات HV bushing loose wrong connection",
],
[
  "transformer-045",
  "Bushing الجهد العالي",
  "قراءة أو خرج Bushing الجهد العالي مو طبيعي",
  "قراءة أو خرج Bushing الجهد العالي أعلى أو أقل أو مختلف عن المطلوب.",
  "قراءة أو خرج غير طبيعي",
  [C("إعداد أو معايرة غلط", 35), C("مصدر أو حمل مو طبيعي", 30), C("المكوّن أو الحساس المرتبط بيه متضرر", 20), C("تقادم أو ضعف بالعزل", 15)],
  ["قارن القراءة بالمواصفات أو بقياس مرجعي.", "راجع الإعدادات والمكوّن المرتبط بالقياس."],
  "متوسطة",
  "المحولات HV bushing abnormal reading output",
],
[
  "transformer-046",
  "Bushing الجهد الواطي",
  "Bushing الجهد الواطي ما يشتغل أو ما ينفذ وظيفته",
  "وظيفة Bushing الجهد الواطي متوقفة أو مو موجودة بالصورة الطبيعية.",
  "توقف وظيفة Bushing الجهد الواطي",
  [C("تغذية أو إشارة مفقودة", 35), C("المكوّن نفسه متضرر", 30), C("توصيل أو حماية مانعة التشغيل", 20), C("تقادم أو ضعف بالعزل", 15)],
  ["افحص التغذية والحماية والتوصيلات.", "بدل أو صلح الجزء المتضرر بعد العزل."],
  "عالية",
  "المحولات LV bushing not working open",
],
[
  "transformer-047",
  "Bushing الجهد الواطي",
  "حرارة Bushing الجهد الواطي ترتفع",
  "حرارة Bushing الجهد الواطي أعلى من الطبيعي أثناء التشغيل.",
  "ارتفاع حرارة Bushing الجهد الواطي",
  [C("تحميل أعلى من التصميم", 35), C("ربط مقاومته عالية", 30), C("تهوية أو تبريد غير كافي", 20), C("تقادم أو ضعف بالعزل", 15)],
  ["خفف الحمل إذا ممكن وافحص التبريد.", "اعزل المعدة إذا الحرارة أو ريحة الحرك قوية."],
  "حرجة",
  "المحولات LV bushing overheating hot",
],
[
  "transformer-048",
  "Bushing الجهد الواطي",
  "Bushing الجهد الواطي يشتغل أو يقرا بصورة غير مستقرة",
  "أداء أو قراءة Bushing الجهد الواطي تتغير أو تقطع بدون سبب طبيعي.",
  "تشغيل أو قراءة متقطعة",
  [C("ترمنل أو وصلة مرخية", 35), C("تغذية أو إشارة متذبذبة", 30), C("المكوّن بدأ يتدهور", 20), C("تقادم أو ضعف بالعزل", 15)],
  ["راقب الحالة وقت ظهور العطل.", "افحص الربطات والتغذية والإشارة المرتبطة بالمكوّن."],
  "عالية",
  "المحولات LV bushing intermittent unstable",
],
[
  "transformer-049",
  "Bushing الجهد الواطي",
  "Bushing الجهد الواطي بيه ربط أو توصيل مو صحيح",
  "أكو ربط مرخي أو توصيل مو مطابق أو نقطة تلامس ضعيفة مرتبطة بـ Bushing الجهد الواطي.",
  "ربط أو توصيل غير سليم",
  [C("برغي أو ترمنل مرخي", 35), C("توصيل سابق مو مطابق", 30), C("أكسدة أو تلف بنقطة الربط", 20), C("تقادم أو ضعف بالعزل", 15)],
  ["اعزل التغذية قبل إعادة الربط.", "نظف أو بدل اللگ أو الترمنل المتضرر."],
  "حرجة",
  "المحولات LV bushing loose wrong connection",
],
[
  "transformer-050",
  "Bushing الجهد الواطي",
  "قراءة أو خرج Bushing الجهد الواطي مو طبيعي",
  "قراءة أو خرج Bushing الجهد الواطي أعلى أو أقل أو مختلف عن المطلوب.",
  "قراءة أو خرج غير طبيعي",
  [C("إعداد أو معايرة غلط", 35), C("مصدر أو حمل مو طبيعي", 30), C("المكوّن أو الحساس المرتبط بيه متضرر", 20), C("تقادم أو ضعف بالعزل", 15)],
  ["قارن القراءة بالمواصفات أو بقياس مرجعي.", "راجع الإعدادات والمكوّن المرتبط بالقياس."],
  "متوسطة",
  "المحولات LV bushing abnormal reading output",
],
[
  "transformer-051",
  "Tap Changer",
  "Tap Changer ما يشتغل أو ما ينفذ وظيفته",
  "وظيفة Tap Changer متوقفة أو مو موجودة بالصورة الطبيعية.",
  "توقف وظيفة Tap Changer",
  [C("تغذية أو إشارة مفقودة", 35), C("المكوّن نفسه متضرر", 30), C("توصيل أو حماية مانعة التشغيل", 20), C("تقادم أو ضعف بالعزل", 15)],
  ["افحص التغذية والحماية والتوصيلات.", "بدل أو صلح الجزء المتضرر بعد العزل."],
  "عالية",
  "المحولات tap changer not working open",
],
[
  "transformer-052",
  "Tap Changer",
  "حرارة Tap Changer ترتفع",
  "حرارة Tap Changer أعلى من الطبيعي أثناء التشغيل.",
  "ارتفاع حرارة Tap Changer",
  [C("تحميل أعلى من التصميم", 35), C("ربط مقاومته عالية", 30), C("تهوية أو تبريد غير كافي", 20), C("تقادم أو ضعف بالعزل", 15)],
  ["خفف الحمل إذا ممكن وافحص التبريد.", "اعزل المعدة إذا الحرارة أو ريحة الحرك قوية."],
  "حرجة",
  "المحولات tap changer overheating hot",
],
[
  "transformer-053",
  "Tap Changer",
  "Tap Changer يشتغل أو يقرا بصورة غير مستقرة",
  "أداء أو قراءة Tap Changer تتغير أو تقطع بدون سبب طبيعي.",
  "تشغيل أو قراءة متقطعة",
  [C("ترمنل أو وصلة مرخية", 35), C("تغذية أو إشارة متذبذبة", 30), C("المكوّن بدأ يتدهور", 20), C("تقادم أو ضعف بالعزل", 15)],
  ["راقب الحالة وقت ظهور العطل.", "افحص الربطات والتغذية والإشارة المرتبطة بالمكوّن."],
  "عالية",
  "المحولات tap changer intermittent unstable",
],
[
  "transformer-054",
  "Tap Changer",
  "Tap Changer بيه ربط أو توصيل مو صحيح",
  "أكو ربط مرخي أو توصيل مو مطابق أو نقطة تلامس ضعيفة مرتبطة بـ Tap Changer.",
  "ربط أو توصيل غير سليم",
  [C("برغي أو ترمنل مرخي", 35), C("توصيل سابق مو مطابق", 30), C("أكسدة أو تلف بنقطة الربط", 20), C("تقادم أو ضعف بالعزل", 15)],
  ["اعزل التغذية قبل إعادة الربط.", "نظف أو بدل اللگ أو الترمنل المتضرر."],
  "حرجة",
  "المحولات tap changer loose wrong connection",
],
[
  "transformer-055",
  "Tap Changer",
  "قراءة أو خرج Tap Changer مو طبيعي",
  "قراءة أو خرج Tap Changer أعلى أو أقل أو مختلف عن المطلوب.",
  "قراءة أو خرج غير طبيعي",
  [C("إعداد أو معايرة غلط", 35), C("مصدر أو حمل مو طبيعي", 30), C("المكوّن أو الحساس المرتبط بيه متضرر", 20), C("تقادم أو ضعف بالعزل", 15)],
  ["قارن القراءة بالمواصفات أو بقياس مرجعي.", "راجع الإعدادات والمكوّن المرتبط بالقياس."],
  "متوسطة",
  "المحولات tap changer abnormal reading output",
],
[
  "transformer-056",
  "OLTC Motor Drive",
  "OLTC Motor Drive ما يشتغل أو ما ينفذ وظيفته",
  "وظيفة OLTC Motor Drive متوقفة أو مو موجودة بالصورة الطبيعية.",
  "توقف وظيفة OLTC Motor Drive",
  [C("تغذية أو إشارة مفقودة", 35), C("المكوّن نفسه متضرر", 30), C("توصيل أو حماية مانعة التشغيل", 20), C("تقادم أو ضعف بالعزل", 15)],
  ["افحص التغذية والحماية والتوصيلات.", "بدل أو صلح الجزء المتضرر بعد العزل."],
  "عالية",
  "المحولات oltc motor not working open",
],
[
  "transformer-057",
  "OLTC Motor Drive",
  "حرارة OLTC Motor Drive ترتفع",
  "حرارة OLTC Motor Drive أعلى من الطبيعي أثناء التشغيل.",
  "ارتفاع حرارة OLTC Motor Drive",
  [C("تحميل أعلى من التصميم", 35), C("ربط مقاومته عالية", 30), C("تهوية أو تبريد غير كافي", 20), C("تقادم أو ضعف بالعزل", 15)],
  ["خفف الحمل إذا ممكن وافحص التبريد.", "اعزل المعدة إذا الحرارة أو ريحة الحرك قوية."],
  "حرجة",
  "المحولات oltc motor overheating hot",
],
[
  "transformer-058",
  "OLTC Motor Drive",
  "OLTC Motor Drive يشتغل أو يقرا بصورة غير مستقرة",
  "أداء أو قراءة OLTC Motor Drive تتغير أو تقطع بدون سبب طبيعي.",
  "تشغيل أو قراءة متقطعة",
  [C("ترمنل أو وصلة مرخية", 35), C("تغذية أو إشارة متذبذبة", 30), C("المكوّن بدأ يتدهور", 20), C("تقادم أو ضعف بالعزل", 15)],
  ["راقب الحالة وقت ظهور العطل.", "افحص الربطات والتغذية والإشارة المرتبطة بالمكوّن."],
  "عالية",
  "المحولات oltc motor intermittent unstable",
],
[
  "transformer-059",
  "OLTC Motor Drive",
  "OLTC Motor Drive بيه ربط أو توصيل مو صحيح",
  "أكو ربط مرخي أو توصيل مو مطابق أو نقطة تلامس ضعيفة مرتبطة بـ OLTC Motor Drive.",
  "ربط أو توصيل غير سليم",
  [C("برغي أو ترمنل مرخي", 35), C("توصيل سابق مو مطابق", 30), C("أكسدة أو تلف بنقطة الربط", 20), C("تقادم أو ضعف بالعزل", 15)],
  ["اعزل التغذية قبل إعادة الربط.", "نظف أو بدل اللگ أو الترمنل المتضرر."],
  "حرجة",
  "المحولات oltc motor loose wrong connection",
],
[
  "transformer-060",
  "OLTC Motor Drive",
  "قراءة أو خرج OLTC Motor Drive مو طبيعي",
  "قراءة أو خرج OLTC Motor Drive أعلى أو أقل أو مختلف عن المطلوب.",
  "قراءة أو خرج غير طبيعي",
  [C("إعداد أو معايرة غلط", 35), C("مصدر أو حمل مو طبيعي", 30), C("المكوّن أو الحساس المرتبط بيه متضرر", 20), C("تقادم أو ضعف بالعزل", 15)],
  ["قارن القراءة بالمواصفات أو بقياس مرجعي.", "راجع الإعدادات والمكوّن المرتبط بالقياس."],
  "متوسطة",
  "المحولات oltc motor abnormal reading output",
],
[
  "transformer-061",
  "Buchholz Relay",
  "Buchholz Relay ما يشتغل أو ما ينفذ وظيفته",
  "وظيفة Buchholz Relay متوقفة أو مو موجودة بالصورة الطبيعية.",
  "توقف وظيفة Buchholz Relay",
  [C("تغذية أو إشارة مفقودة", 35), C("المكوّن نفسه متضرر", 30), C("توصيل أو حماية مانعة التشغيل", 20), C("تقادم أو ضعف بالعزل", 15)],
  ["افحص التغذية والحماية والتوصيلات.", "بدل أو صلح الجزء المتضرر بعد العزل."],
  "عالية",
  "المحولات buchholz relay not working open",
],
[
  "transformer-062",
  "Buchholz Relay",
  "حرارة Buchholz Relay ترتفع",
  "حرارة Buchholz Relay أعلى من الطبيعي أثناء التشغيل.",
  "ارتفاع حرارة Buchholz Relay",
  [C("تحميل أعلى من التصميم", 35), C("ربط مقاومته عالية", 30), C("تهوية أو تبريد غير كافي", 20), C("تقادم أو ضعف بالعزل", 15)],
  ["خفف الحمل إذا ممكن وافحص التبريد.", "اعزل المعدة إذا الحرارة أو ريحة الحرك قوية."],
  "حرجة",
  "المحولات buchholz relay overheating hot",
],
[
  "transformer-063",
  "Buchholz Relay",
  "Buchholz Relay يشتغل أو يقرا بصورة غير مستقرة",
  "أداء أو قراءة Buchholz Relay تتغير أو تقطع بدون سبب طبيعي.",
  "تشغيل أو قراءة متقطعة",
  [C("ترمنل أو وصلة مرخية", 35), C("تغذية أو إشارة متذبذبة", 30), C("المكوّن بدأ يتدهور", 20), C("تقادم أو ضعف بالعزل", 15)],
  ["راقب الحالة وقت ظهور العطل.", "افحص الربطات والتغذية والإشارة المرتبطة بالمكوّن."],
  "عالية",
  "المحولات buchholz relay intermittent unstable",
],
[
  "transformer-064",
  "Buchholz Relay",
  "Buchholz Relay بيه ربط أو توصيل مو صحيح",
  "أكو ربط مرخي أو توصيل مو مطابق أو نقطة تلامس ضعيفة مرتبطة بـ Buchholz Relay.",
  "ربط أو توصيل غير سليم",
  [C("برغي أو ترمنل مرخي", 35), C("توصيل سابق مو مطابق", 30), C("أكسدة أو تلف بنقطة الربط", 20), C("تقادم أو ضعف بالعزل", 15)],
  ["اعزل التغذية قبل إعادة الربط.", "نظف أو بدل اللگ أو الترمنل المتضرر."],
  "حرجة",
  "المحولات buchholz relay loose wrong connection",
],
[
  "transformer-065",
  "Buchholz Relay",
  "قراءة أو خرج Buchholz Relay مو طبيعي",
  "قراءة أو خرج Buchholz Relay أعلى أو أقل أو مختلف عن المطلوب.",
  "قراءة أو خرج غير طبيعي",
  [C("إعداد أو معايرة غلط", 35), C("مصدر أو حمل مو طبيعي", 30), C("المكوّن أو الحساس المرتبط بيه متضرر", 20), C("تقادم أو ضعف بالعزل", 15)],
  ["قارن القراءة بالمواصفات أو بقياس مرجعي.", "راجع الإعدادات والمكوّن المرتبط بالقياس."],
  "متوسطة",
  "المحولات buchholz relay abnormal reading output",
],
[
  "transformer-066",
  "Pressure Relief Device",
  "Pressure Relief Device ما يشتغل أو ما ينفذ وظيفته",
  "وظيفة Pressure Relief Device متوقفة أو مو موجودة بالصورة الطبيعية.",
  "توقف وظيفة Pressure Relief Device",
  [C("تغذية أو إشارة مفقودة", 35), C("المكوّن نفسه متضرر", 30), C("توصيل أو حماية مانعة التشغيل", 20), C("تقادم أو ضعف بالعزل", 15)],
  ["افحص التغذية والحماية والتوصيلات.", "بدل أو صلح الجزء المتضرر بعد العزل."],
  "عالية",
  "المحولات pressure relief not working open",
],
[
  "transformer-067",
  "Pressure Relief Device",
  "حرارة Pressure Relief Device ترتفع",
  "حرارة Pressure Relief Device أعلى من الطبيعي أثناء التشغيل.",
  "ارتفاع حرارة Pressure Relief Device",
  [C("تحميل أعلى من التصميم", 35), C("ربط مقاومته عالية", 30), C("تهوية أو تبريد غير كافي", 20), C("تقادم أو ضعف بالعزل", 15)],
  ["خفف الحمل إذا ممكن وافحص التبريد.", "اعزل المعدة إذا الحرارة أو ريحة الحرك قوية."],
  "حرجة",
  "المحولات pressure relief overheating hot",
],
[
  "transformer-068",
  "Pressure Relief Device",
  "Pressure Relief Device يشتغل أو يقرا بصورة غير مستقرة",
  "أداء أو قراءة Pressure Relief Device تتغير أو تقطع بدون سبب طبيعي.",
  "تشغيل أو قراءة متقطعة",
  [C("ترمنل أو وصلة مرخية", 35), C("تغذية أو إشارة متذبذبة", 30), C("المكوّن بدأ يتدهور", 20), C("تقادم أو ضعف بالعزل", 15)],
  ["راقب الحالة وقت ظهور العطل.", "افحص الربطات والتغذية والإشارة المرتبطة بالمكوّن."],
  "عالية",
  "المحولات pressure relief intermittent unstable",
],
[
  "transformer-069",
  "Pressure Relief Device",
  "Pressure Relief Device بيه ربط أو توصيل مو صحيح",
  "أكو ربط مرخي أو توصيل مو مطابق أو نقطة تلامس ضعيفة مرتبطة بـ Pressure Relief Device.",
  "ربط أو توصيل غير سليم",
  [C("برغي أو ترمنل مرخي", 35), C("توصيل سابق مو مطابق", 30), C("أكسدة أو تلف بنقطة الربط", 20), C("تقادم أو ضعف بالعزل", 15)],
  ["اعزل التغذية قبل إعادة الربط.", "نظف أو بدل اللگ أو الترمنل المتضرر."],
  "حرجة",
  "المحولات pressure relief loose wrong connection",
],
[
  "transformer-070",
  "Pressure Relief Device",
  "قراءة أو خرج Pressure Relief Device مو طبيعي",
  "قراءة أو خرج Pressure Relief Device أعلى أو أقل أو مختلف عن المطلوب.",
  "قراءة أو خرج غير طبيعي",
  [C("إعداد أو معايرة غلط", 35), C("مصدر أو حمل مو طبيعي", 30), C("المكوّن أو الحساس المرتبط بيه متضرر", 20), C("تقادم أو ضعف بالعزل", 15)],
  ["قارن القراءة بالمواصفات أو بقياس مرجعي.", "راجع الإعدادات والمكوّن المرتبط بالقياس."],
  "متوسطة",
  "المحولات pressure relief abnormal reading output",
],
[
  "transformer-071",
  "حساس حرارة الزيت",
  "حساس حرارة الزيت ما يشتغل أو ما ينفذ وظيفته",
  "وظيفة حساس حرارة الزيت متوقفة أو مو موجودة بالصورة الطبيعية.",
  "توقف وظيفة حساس حرارة الزيت",
  [C("تغذية أو إشارة مفقودة", 35), C("المكوّن نفسه متضرر", 30), C("توصيل أو حماية مانعة التشغيل", 20), C("تقادم أو ضعف بالعزل", 15)],
  ["افحص التغذية والحماية والتوصيلات.", "بدل أو صلح الجزء المتضرر بعد العزل."],
  "عالية",
  "المحولات oil temp sensor not working open",
],
[
  "transformer-072",
  "حساس حرارة الزيت",
  "حرارة حساس حرارة الزيت ترتفع",
  "حرارة حساس حرارة الزيت أعلى من الطبيعي أثناء التشغيل.",
  "ارتفاع حرارة حساس حرارة الزيت",
  [C("تحميل أعلى من التصميم", 35), C("ربط مقاومته عالية", 30), C("تهوية أو تبريد غير كافي", 20), C("تقادم أو ضعف بالعزل", 15)],
  ["خفف الحمل إذا ممكن وافحص التبريد.", "اعزل المعدة إذا الحرارة أو ريحة الحرك قوية."],
  "حرجة",
  "المحولات oil temp sensor overheating hot",
],
[
  "transformer-073",
  "حساس حرارة الزيت",
  "حساس حرارة الزيت يشتغل أو يقرا بصورة غير مستقرة",
  "أداء أو قراءة حساس حرارة الزيت تتغير أو تقطع بدون سبب طبيعي.",
  "تشغيل أو قراءة متقطعة",
  [C("ترمنل أو وصلة مرخية", 35), C("تغذية أو إشارة متذبذبة", 30), C("المكوّن بدأ يتدهور", 20), C("تقادم أو ضعف بالعزل", 15)],
  ["راقب الحالة وقت ظهور العطل.", "افحص الربطات والتغذية والإشارة المرتبطة بالمكوّن."],
  "عالية",
  "المحولات oil temp sensor intermittent unstable",
],
[
  "transformer-074",
  "حساس حرارة الزيت",
  "حساس حرارة الزيت بيه ربط أو توصيل مو صحيح",
  "أكو ربط مرخي أو توصيل مو مطابق أو نقطة تلامس ضعيفة مرتبطة بـ حساس حرارة الزيت.",
  "ربط أو توصيل غير سليم",
  [C("برغي أو ترمنل مرخي", 35), C("توصيل سابق مو مطابق", 30), C("أكسدة أو تلف بنقطة الربط", 20), C("تقادم أو ضعف بالعزل", 15)],
  ["اعزل التغذية قبل إعادة الربط.", "نظف أو بدل اللگ أو الترمنل المتضرر."],
  "حرجة",
  "المحولات oil temp sensor loose wrong connection",
],
[
  "transformer-075",
  "حساس حرارة الزيت",
  "قراءة أو خرج حساس حرارة الزيت مو طبيعي",
  "قراءة أو خرج حساس حرارة الزيت أعلى أو أقل أو مختلف عن المطلوب.",
  "قراءة أو خرج غير طبيعي",
  [C("إعداد أو معايرة غلط", 35), C("مصدر أو حمل مو طبيعي", 30), C("المكوّن أو الحساس المرتبط بيه متضرر", 20), C("تقادم أو ضعف بالعزل", 15)],
  ["قارن القراءة بالمواصفات أو بقياس مرجعي.", "راجع الإعدادات والمكوّن المرتبط بالقياس."],
  "متوسطة",
  "المحولات oil temp sensor abnormal reading output",
],
[
  "transformer-076",
  "حساس حرارة الملفات",
  "حساس حرارة الملفات ما يشتغل أو ما ينفذ وظيفته",
  "وظيفة حساس حرارة الملفات متوقفة أو مو موجودة بالصورة الطبيعية.",
  "توقف وظيفة حساس حرارة الملفات",
  [C("تغذية أو إشارة مفقودة", 35), C("المكوّن نفسه متضرر", 30), C("توصيل أو حماية مانعة التشغيل", 20), C("تقادم أو ضعف بالعزل", 15)],
  ["افحص التغذية والحماية والتوصيلات.", "بدل أو صلح الجزء المتضرر بعد العزل."],
  "عالية",
  "المحولات winding temp sensor not working open",
],
[
  "transformer-077",
  "حساس حرارة الملفات",
  "حرارة حساس حرارة الملفات ترتفع",
  "حرارة حساس حرارة الملفات أعلى من الطبيعي أثناء التشغيل.",
  "ارتفاع حرارة حساس حرارة الملفات",
  [C("تحميل أعلى من التصميم", 35), C("ربط مقاومته عالية", 30), C("تهوية أو تبريد غير كافي", 20), C("تقادم أو ضعف بالعزل", 15)],
  ["خفف الحمل إذا ممكن وافحص التبريد.", "اعزل المعدة إذا الحرارة أو ريحة الحرك قوية."],
  "حرجة",
  "المحولات winding temp sensor overheating hot",
],
[
  "transformer-078",
  "حساس حرارة الملفات",
  "حساس حرارة الملفات يشتغل أو يقرا بصورة غير مستقرة",
  "أداء أو قراءة حساس حرارة الملفات تتغير أو تقطع بدون سبب طبيعي.",
  "تشغيل أو قراءة متقطعة",
  [C("ترمنل أو وصلة مرخية", 35), C("تغذية أو إشارة متذبذبة", 30), C("المكوّن بدأ يتدهور", 20), C("تقادم أو ضعف بالعزل", 15)],
  ["راقب الحالة وقت ظهور العطل.", "افحص الربطات والتغذية والإشارة المرتبطة بالمكوّن."],
  "عالية",
  "المحولات winding temp sensor intermittent unstable",
],
[
  "transformer-079",
  "حساس حرارة الملفات",
  "حساس حرارة الملفات بيه ربط أو توصيل مو صحيح",
  "أكو ربط مرخي أو توصيل مو مطابق أو نقطة تلامس ضعيفة مرتبطة بـ حساس حرارة الملفات.",
  "ربط أو توصيل غير سليم",
  [C("برغي أو ترمنل مرخي", 35), C("توصيل سابق مو مطابق", 30), C("أكسدة أو تلف بنقطة الربط", 20), C("تقادم أو ضعف بالعزل", 15)],
  ["اعزل التغذية قبل إعادة الربط.", "نظف أو بدل اللگ أو الترمنل المتضرر."],
  "حرجة",
  "المحولات winding temp sensor loose wrong connection",
],
[
  "transformer-080",
  "حساس حرارة الملفات",
  "قراءة أو خرج حساس حرارة الملفات مو طبيعي",
  "قراءة أو خرج حساس حرارة الملفات أعلى أو أقل أو مختلف عن المطلوب.",
  "قراءة أو خرج غير طبيعي",
  [C("إعداد أو معايرة غلط", 35), C("مصدر أو حمل مو طبيعي", 30), C("المكوّن أو الحساس المرتبط بيه متضرر", 20), C("تقادم أو ضعف بالعزل", 15)],
  ["قارن القراءة بالمواصفات أو بقياس مرجعي.", "راجع الإعدادات والمكوّن المرتبط بالقياس."],
  "متوسطة",
  "المحولات winding temp sensor abnormal reading output",
],
[
  "transformer-081",
  "Radiator المبرد",
  "Radiator المبرد ما يشتغل أو ما ينفذ وظيفته",
  "وظيفة Radiator المبرد متوقفة أو مو موجودة بالصورة الطبيعية.",
  "توقف وظيفة Radiator المبرد",
  [C("تغذية أو إشارة مفقودة", 35), C("المكوّن نفسه متضرر", 30), C("توصيل أو حماية مانعة التشغيل", 20), C("تقادم أو ضعف بالعزل", 15)],
  ["افحص التغذية والحماية والتوصيلات.", "بدل أو صلح الجزء المتضرر بعد العزل."],
  "عالية",
  "المحولات radiator not working open",
],
[
  "transformer-082",
  "Radiator المبرد",
  "حرارة Radiator المبرد ترتفع",
  "حرارة Radiator المبرد أعلى من الطبيعي أثناء التشغيل.",
  "ارتفاع حرارة Radiator المبرد",
  [C("تحميل أعلى من التصميم", 35), C("ربط مقاومته عالية", 30), C("تهوية أو تبريد غير كافي", 20), C("تقادم أو ضعف بالعزل", 15)],
  ["خفف الحمل إذا ممكن وافحص التبريد.", "اعزل المعدة إذا الحرارة أو ريحة الحرك قوية."],
  "حرجة",
  "المحولات radiator overheating hot",
],
[
  "transformer-083",
  "Radiator المبرد",
  "Radiator المبرد يشتغل أو يقرا بصورة غير مستقرة",
  "أداء أو قراءة Radiator المبرد تتغير أو تقطع بدون سبب طبيعي.",
  "تشغيل أو قراءة متقطعة",
  [C("ترمنل أو وصلة مرخية", 35), C("تغذية أو إشارة متذبذبة", 30), C("المكوّن بدأ يتدهور", 20), C("تقادم أو ضعف بالعزل", 15)],
  ["راقب الحالة وقت ظهور العطل.", "افحص الربطات والتغذية والإشارة المرتبطة بالمكوّن."],
  "عالية",
  "المحولات radiator intermittent unstable",
],
[
  "transformer-084",
  "Radiator المبرد",
  "Radiator المبرد بيه ربط أو توصيل مو صحيح",
  "أكو ربط مرخي أو توصيل مو مطابق أو نقطة تلامس ضعيفة مرتبطة بـ Radiator المبرد.",
  "ربط أو توصيل غير سليم",
  [C("برغي أو ترمنل مرخي", 35), C("توصيل سابق مو مطابق", 30), C("أكسدة أو تلف بنقطة الربط", 20), C("تقادم أو ضعف بالعزل", 15)],
  ["اعزل التغذية قبل إعادة الربط.", "نظف أو بدل اللگ أو الترمنل المتضرر."],
  "حرجة",
  "المحولات radiator loose wrong connection",
],
[
  "transformer-085",
  "Radiator المبرد",
  "قراءة أو خرج Radiator المبرد مو طبيعي",
  "قراءة أو خرج Radiator المبرد أعلى أو أقل أو مختلف عن المطلوب.",
  "قراءة أو خرج غير طبيعي",
  [C("إعداد أو معايرة غلط", 35), C("مصدر أو حمل مو طبيعي", 30), C("المكوّن أو الحساس المرتبط بيه متضرر", 20), C("تقادم أو ضعف بالعزل", 15)],
  ["قارن القراءة بالمواصفات أو بقياس مرجعي.", "راجع الإعدادات والمكوّن المرتبط بالقياس."],
  "متوسطة",
  "المحولات radiator abnormal reading output",
],
[
  "transformer-086",
  "مراوح التبريد",
  "مراوح التبريد ما يشتغل أو ما ينفذ وظيفته",
  "وظيفة مراوح التبريد متوقفة أو مو موجودة بالصورة الطبيعية.",
  "توقف وظيفة مراوح التبريد",
  [C("تغذية أو إشارة مفقودة", 35), C("المكوّن نفسه متضرر", 30), C("توصيل أو حماية مانعة التشغيل", 20), C("تقادم أو ضعف بالعزل", 15)],
  ["افحص التغذية والحماية والتوصيلات.", "بدل أو صلح الجزء المتضرر بعد العزل."],
  "عالية",
  "المحولات cooling fans not working open",
],
[
  "transformer-087",
  "مراوح التبريد",
  "حرارة مراوح التبريد ترتفع",
  "حرارة مراوح التبريد أعلى من الطبيعي أثناء التشغيل.",
  "ارتفاع حرارة مراوح التبريد",
  [C("تحميل أعلى من التصميم", 35), C("ربط مقاومته عالية", 30), C("تهوية أو تبريد غير كافي", 20), C("تقادم أو ضعف بالعزل", 15)],
  ["خفف الحمل إذا ممكن وافحص التبريد.", "اعزل المعدة إذا الحرارة أو ريحة الحرك قوية."],
  "حرجة",
  "المحولات cooling fans overheating hot",
],
[
  "transformer-088",
  "مراوح التبريد",
  "مراوح التبريد يشتغل أو يقرا بصورة غير مستقرة",
  "أداء أو قراءة مراوح التبريد تتغير أو تقطع بدون سبب طبيعي.",
  "تشغيل أو قراءة متقطعة",
  [C("ترمنل أو وصلة مرخية", 35), C("تغذية أو إشارة متذبذبة", 30), C("المكوّن بدأ يتدهور", 20), C("تقادم أو ضعف بالعزل", 15)],
  ["راقب الحالة وقت ظهور العطل.", "افحص الربطات والتغذية والإشارة المرتبطة بالمكوّن."],
  "عالية",
  "المحولات cooling fans intermittent unstable",
],
[
  "transformer-089",
  "مراوح التبريد",
  "مراوح التبريد بيه ربط أو توصيل مو صحيح",
  "أكو ربط مرخي أو توصيل مو مطابق أو نقطة تلامس ضعيفة مرتبطة بـ مراوح التبريد.",
  "ربط أو توصيل غير سليم",
  [C("برغي أو ترمنل مرخي", 35), C("توصيل سابق مو مطابق", 30), C("أكسدة أو تلف بنقطة الربط", 20), C("تقادم أو ضعف بالعزل", 15)],
  ["اعزل التغذية قبل إعادة الربط.", "نظف أو بدل اللگ أو الترمنل المتضرر."],
  "حرجة",
  "المحولات cooling fans loose wrong connection",
],
[
  "transformer-090",
  "مراوح التبريد",
  "قراءة أو خرج مراوح التبريد مو طبيعي",
  "قراءة أو خرج مراوح التبريد أعلى أو أقل أو مختلف عن المطلوب.",
  "قراءة أو خرج غير طبيعي",
  [C("إعداد أو معايرة غلط", 35), C("مصدر أو حمل مو طبيعي", 30), C("المكوّن أو الحساس المرتبط بيه متضرر", 20), C("تقادم أو ضعف بالعزل", 15)],
  ["قارن القراءة بالمواصفات أو بقياس مرجعي.", "راجع الإعدادات والمكوّن المرتبط بالقياس."],
  "متوسطة",
  "المحولات cooling fans abnormal reading output",
],
[
  "transformer-091",
  "مضخة الزيت",
  "مضخة الزيت ما يشتغل أو ما ينفذ وظيفته",
  "وظيفة مضخة الزيت متوقفة أو مو موجودة بالصورة الطبيعية.",
  "توقف وظيفة مضخة الزيت",
  [C("تغذية أو إشارة مفقودة", 35), C("المكوّن نفسه متضرر", 30), C("توصيل أو حماية مانعة التشغيل", 20), C("تقادم أو ضعف بالعزل", 15)],
  ["افحص التغذية والحماية والتوصيلات.", "بدل أو صلح الجزء المتضرر بعد العزل."],
  "عالية",
  "المحولات oil pump not working open",
],
[
  "transformer-092",
  "مضخة الزيت",
  "حرارة مضخة الزيت ترتفع",
  "حرارة مضخة الزيت أعلى من الطبيعي أثناء التشغيل.",
  "ارتفاع حرارة مضخة الزيت",
  [C("تحميل أعلى من التصميم", 35), C("ربط مقاومته عالية", 30), C("تهوية أو تبريد غير كافي", 20), C("تقادم أو ضعف بالعزل", 15)],
  ["خفف الحمل إذا ممكن وافحص التبريد.", "اعزل المعدة إذا الحرارة أو ريحة الحرك قوية."],
  "حرجة",
  "المحولات oil pump overheating hot",
],
[
  "transformer-093",
  "مضخة الزيت",
  "مضخة الزيت يشتغل أو يقرا بصورة غير مستقرة",
  "أداء أو قراءة مضخة الزيت تتغير أو تقطع بدون سبب طبيعي.",
  "تشغيل أو قراءة متقطعة",
  [C("ترمنل أو وصلة مرخية", 35), C("تغذية أو إشارة متذبذبة", 30), C("المكوّن بدأ يتدهور", 20), C("تقادم أو ضعف بالعزل", 15)],
  ["راقب الحالة وقت ظهور العطل.", "افحص الربطات والتغذية والإشارة المرتبطة بالمكوّن."],
  "عالية",
  "المحولات oil pump intermittent unstable",
],
[
  "transformer-094",
  "مضخة الزيت",
  "مضخة الزيت بيه ربط أو توصيل مو صحيح",
  "أكو ربط مرخي أو توصيل مو مطابق أو نقطة تلامس ضعيفة مرتبطة بـ مضخة الزيت.",
  "ربط أو توصيل غير سليم",
  [C("برغي أو ترمنل مرخي", 35), C("توصيل سابق مو مطابق", 30), C("أكسدة أو تلف بنقطة الربط", 20), C("تقادم أو ضعف بالعزل", 15)],
  ["اعزل التغذية قبل إعادة الربط.", "نظف أو بدل اللگ أو الترمنل المتضرر."],
  "حرجة",
  "المحولات oil pump loose wrong connection",
],
[
  "transformer-095",
  "مضخة الزيت",
  "قراءة أو خرج مضخة الزيت مو طبيعي",
  "قراءة أو خرج مضخة الزيت أعلى أو أقل أو مختلف عن المطلوب.",
  "قراءة أو خرج غير طبيعي",
  [C("إعداد أو معايرة غلط", 35), C("مصدر أو حمل مو طبيعي", 30), C("المكوّن أو الحساس المرتبط بيه متضرر", 20), C("تقادم أو ضعف بالعزل", 15)],
  ["قارن القراءة بالمواصفات أو بقياس مرجعي.", "راجع الإعدادات والمكوّن المرتبط بالقياس."],
  "متوسطة",
  "المحولات oil pump abnormal reading output",
],
[
  "transformer-096",
  "تأريض المحولة",
  "تأريض المحولة ما يشتغل أو ما ينفذ وظيفته",
  "وظيفة تأريض المحولة متوقفة أو مو موجودة بالصورة الطبيعية.",
  "توقف وظيفة تأريض المحولة",
  [C("تغذية أو إشارة مفقودة", 35), C("المكوّن نفسه متضرر", 30), C("توصيل أو حماية مانعة التشغيل", 20), C("تقادم أو ضعف بالعزل", 15)],
  ["افحص التغذية والحماية والتوصيلات.", "بدل أو صلح الجزء المتضرر بعد العزل."],
  "عالية",
  "المحولات transformer earthing not working open",
],
[
  "transformer-097",
  "تأريض المحولة",
  "حرارة تأريض المحولة ترتفع",
  "حرارة تأريض المحولة أعلى من الطبيعي أثناء التشغيل.",
  "ارتفاع حرارة تأريض المحولة",
  [C("تحميل أعلى من التصميم", 35), C("ربط مقاومته عالية", 30), C("تهوية أو تبريد غير كافي", 20), C("تقادم أو ضعف بالعزل", 15)],
  ["خفف الحمل إذا ممكن وافحص التبريد.", "اعزل المعدة إذا الحرارة أو ريحة الحرك قوية."],
  "حرجة",
  "المحولات transformer earthing overheating hot",
],
[
  "transformer-098",
  "تأريض المحولة",
  "تأريض المحولة يشتغل أو يقرا بصورة غير مستقرة",
  "أداء أو قراءة تأريض المحولة تتغير أو تقطع بدون سبب طبيعي.",
  "تشغيل أو قراءة متقطعة",
  [C("ترمنل أو وصلة مرخية", 35), C("تغذية أو إشارة متذبذبة", 30), C("المكوّن بدأ يتدهور", 20), C("تقادم أو ضعف بالعزل", 15)],
  ["راقب الحالة وقت ظهور العطل.", "افحص الربطات والتغذية والإشارة المرتبطة بالمكوّن."],
  "عالية",
  "المحولات transformer earthing intermittent unstable",
],
[
  "transformer-099",
  "تأريض المحولة",
  "تأريض المحولة بيه ربط أو توصيل مو صحيح",
  "أكو ربط مرخي أو توصيل مو مطابق أو نقطة تلامس ضعيفة مرتبطة بـ تأريض المحولة.",
  "ربط أو توصيل غير سليم",
  [C("برغي أو ترمنل مرخي", 35), C("توصيل سابق مو مطابق", 30), C("أكسدة أو تلف بنقطة الربط", 20), C("تقادم أو ضعف بالعزل", 15)],
  ["اعزل التغذية قبل إعادة الربط.", "نظف أو بدل اللگ أو الترمنل المتضرر."],
  "حرجة",
  "المحولات transformer earthing loose wrong connection",
],
[
  "transformer-100",
  "تأريض المحولة",
  "قراءة أو خرج تأريض المحولة مو طبيعي",
  "قراءة أو خرج تأريض المحولة أعلى أو أقل أو مختلف عن المطلوب.",
  "قراءة أو خرج غير طبيعي",
  [C("إعداد أو معايرة غلط", 35), C("مصدر أو حمل مو طبيعي", 30), C("المكوّن أو الحساس المرتبط بيه متضرر", 20), C("تقادم أو ضعف بالعزل", 15)],
  ["قارن القراءة بالمواصفات أو بقياس مرجعي.", "راجع الإعدادات والمكوّن المرتبط بالقياس."],
  "متوسطة",
  "المحولات transformer earthing abnormal reading output",
],
];

export const transformerFaults: TransformerFault[] = rows.map(
  ([
    id,
    device_ar,
    name_ar,
    description_ar,
    symptom,
    causes,
    solutions,
    severity,
    keywords,
  ]) => {
    const critical = severity === "حرجة";

    return {
      id,
      category_id: null,
      device_ar,
      name_ar,
      description_ar,
      symptoms: [symptom],
      causes,
      tests: [
        {
          test: "الفحص الأولي",
          location: device_ar,
          method: "اعزل الابتدائي والثانوي وأي تغذية راجعة قبل الفحص. انتظر وتأكد من انعدام الجهد قبل لمس الأطراف. اختبارات الجهد العالي والعزل والزيت خليها لفني محولات مؤهل.",
          normal:
            "القراءات والحرارة والتوصيلات ضمن الطبيعي، وماكو حرك أو تسريب أو تقطيع أو تلف واضح.",
          faulty:
            "حرارة عالية أو فصل متكرر أو ربط مرخي أو قراءة غير طبيعية يدل على عطل يحتاج فحص قبل التشغيل.",
        },
      ],
      solutions,
      severity,
      safety_warnings: critical
        ? [
            "تنبيه: اعزل كل مصادر الطاقة قبل الصيانة وانتبه من التغذية الراجعة أو التشغيل الأوتوماتيكي.",
            "العمل أو القياس على أجزاء حية أو جهد عالي خليه لفني مؤهل وبمعدات مناسبة.",
          ]
        : [
            "افصل وعزل التغذية قبل الفك أو إعادة الربط.",
            "إذا شفت شرر أو ذوبان أو ريحة حرك أو تشغيل غير متوقع، وقف المعدة وخلي فني يفحصها.",
          ],
      error_code: null,
      keywords,
      next_question_key: null,
    };
  },
);
